import { defineComponent as _defineComponent } from 'vue'
import { useBreakpoint, useMediaAsset, useSwiperElement } from '~/composables';

interface Props {
  data?: { id?: string; items: any[] };
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CategoryProductSeries',
  props: {
    data: { default: () => ({ items: [] }) }
  },
  setup(__props: any) {



const { getAssetUrl } = useMediaAsset();
const { isBiggerThanBreakpoint: isDesktop } = useBreakpoint('md');

const swiperOptions = {
  observer: true,
  slidesPerView: 'auto',
  spaceBetween: 16,
  scrollbar: {
    el: '.swiper-scrollbar',
    draggable: true,
    dragSize: 180,
    snapOnRelease: true,
  },
};

const swiperEl = useSwiperElement(swiperOptions);

const getImage = (src: string) => getAssetUrl(src) ?? undefined;

return { __sfc: true,getAssetUrl, isDesktop, swiperOptions, swiperEl, getImage }
}

})